import React, { useState } from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { createCustomsRebateRequest } from "../../../redux/actions/FormalityActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/loader/Loader";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

const productFamilies = [
  "Véhicules / pièces détachées",
  "Électronique",
  "Informatique",
  "Vêtements & chaussures",
  "Électroménager",
  "Meubles",
  "Jouets",
  "Bricolage",
  "Cosmétiques",
  "Téléphones / accessoires",
  "Papeterie",
  "Articles de sport",
];

function CustomsRebateProductType() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const [submitting, setSubmitting] = useState(false);

  const handleSelect = async (product) => {
    setSelectedProduct(product);
    setSubmitting(true);

    await dispatch(
      createCustomsRebateRequest(
        user.token,
        {
          productType: product,
          country: cart.country,
        },
        handleCallback
      )
    );
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/formality-documents");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />
      <h4 className="text-center mt-4 mb-4">
        Quel <span style={{ color: "#FF5500" }}>type de produit</span>{" "}
        souhaitez-vous importer ?
      </h4>

      <Container className="mt-4 d-flex justify-content-center">
        <Row className="w-100 " style={{ maxWidth: "1000px" }}>
          {productFamilies.map((product, index) => (
            <Col
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={index}
              className="mb-4 d-flex justify-content-center"
            >
              <Card
                onClick={() => handleSelect(product)}
                style={{
                  width: "100%",
                  height: "100px",
                  cursor: "pointer",
                  border:
                    selectedProduct === product
                      ? "2px solid #FF5500"
                      : "2px solid transparent",
                  boxShadow:
                    selectedProduct === product
                      ? "0 0 10px rgba(255, 85, 0, 0.5)"
                      : "0 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  transition: "all 0.3s ease-in-out",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "#FF5500")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor = "#ddd")
                }
              >
                <Card.Body className="sector-box d-flex flex-column align-items-center justify-content-center">
                  <Card.Title style={{ fontSize: "1rem" }}>
                    {product}
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default CustomsRebateProductType;
